import { RouteConfig } from 'vue-router';

import { EntityType } from '@/enums/entityType.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { Setting } from '@/interfaces/setting';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentValuesRoute: RouteConfig = {
  name: 'documentValues',
  path: 'values',
  component: () => import(/* webpackChunkName: "DocumentValues" */ '@/views/mainRoute/document/details/Values.vue'),
  meta: {},
  beforeEnter(to, from, next) {
    Promise.all([
      getEditableValueCodes(to.params.procedureId.toString(), EntityType.PROCEDURE).then(
        setting => setting || getEditableValueCodes()
      ),
      store.dispatch('document/getDocumentValues', tryParseInt(to.params.documentId))
    ]).then(() => next());
  }
};

function getEditableValueCodes(entityId?: string, entityType?: string): Promise<Setting> {
  return store.dispatch('setting/findPublic', {
    code: PublicSettings.PROCEDURE_EDITABLE_DOCUMENT_VALUE_CODES,
    entityType,
    entityId
  });
}
